import { render, staticRenderFns } from "./DocumentTypeCreate.vue?vue&type=template&id=6ee71faa"
import script from "./DocumentTypeCreate.vue?vue&type=script&lang=js"
export * from "./DocumentTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports